import React from "react";
import Modal from "../ModalTemplate";
import Button from "../Button";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";
import PagesHeader from "@components/PagesHeader";
import BGImg from "./img/bg.webp";
import ActivityPoints from "@components/ActivityPoints";
import SectionHeader from "@components/SectionHeader";

export default NiceModal.create(() => {
  const modal = useModal();
  const points = modal.args?.points ?? 25;

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={"new-year-points-modal"}
    >
      <div className="content-wrapper">
        <SectionHeader
          dangerouslySetInnerHTML={`Du hast <br/><strong>${points} Punkte verdient!</strong>`}
        />
        <div className="img-wrapper">
          <ActivityPoints>{points}</ActivityPoints>
          <img src={BGImg} alt="circles" />
        </div>
        <div className="buttons-wrapper">
          <Button action={modal.hide} btnClass="outline yellow">
            Zurück zu den Challenges
          </Button>
          <Button href={"/coupons"} action={modal.hide}>
            Punkte eintauschen
          </Button>
        </div>
      </div>
    </Modal>
  );
});
